import React, { useState } from 'react';
import CategoryList from '../components/products/CategoryList';
import StorefrontCategoryList from '../components/products/StorefrontCategoryList';

const ACTIVE_CATEGORY_VIEW_KEY = 'jdh:crm:list:categories-page:active-tab';

const CATEGORY_VIEWS = [
  { id: 'internal', label: 'Internal / ERP Categories' },
  { id: 'storefront', label: 'Storefront Categories' },
];

function CategoriesPage() {
  const [activeView, setActiveView] = useState(() => {
    try {
      const stored = localStorage.getItem(ACTIVE_CATEGORY_VIEW_KEY);
      return CATEGORY_VIEWS.some((view) => view.id === stored) ? stored : 'internal';
    } catch {
      return 'internal';
    }
  });
  const changeView = (viewId) => {
    if (!CATEGORY_VIEWS.some((view) => view.id === viewId)) return;
    setActiveView(viewId);
    try { localStorage.setItem(ACTIVE_CATEGORY_VIEW_KEY, viewId); } catch { /* session state still works */ }
  };
  const sharedViewProps = {
    staticViews: CATEGORY_VIEWS,
    activeStaticView: activeView,
    onStaticViewChange: changeView,
  };

  return (
    <div className="catalog-categories-page">
      <div className="catalog-categories-page__content">
        {activeView === 'internal'
          ? <CategoryList {...sharedViewProps} />
          : <StorefrontCategoryList {...sharedViewProps} />}
      </div>
    </div>
  );
}

export default CategoriesPage;
